/* eslint-disable jsx-a11y/anchor-is-valid, no-param-reassign,
no-plusplus, react/no-array-index-key */
/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import $ from 'jquery';
import classnames from 'classnames';
import { isValidUrl } from '@bingads-webui/url-util';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';
import { AdStrengthSuggestionRepository } from './asset-suggestion-repository';
import { containerExists } from './asset-suggestion-helper';
import { singleAssetSuggestionType, assetSuggestionType, headlineFields, longHeadlineFields, descriptionFields } from '../constants';

export class AdStrengthSuggestionPicker extends React.Component {
  static defaultProps = {
    itemsToDisplay: [],
    container: $(document.body),
    permissions: {},
  };

  getDisplayPosition(target, container, permissions) {
    const $target = $(target);
    const targetOffset = $target.offset();
    const containerOffset = container.offset();

    let assetSectionHeight = 0;
    let hrHeight = 0;
    const $panel = $('.ad-edit-and-preview-container .collapsible-panel');
    if (permissions.IsMultiMediaAdsPhase2Enabled && $panel.length > 0) {
      assetSectionHeight = $panel.outerHeight();
      const hrStyle = window.getComputedStyle($('.ad-edit-and-preview-container hr')[0]);
      hrHeight = parseInt(hrStyle.marginTop, 10) + parseInt(hrStyle.marginBottom, 10) +
        parseInt(hrStyle.borderTopWidth, 10) + parseInt(hrStyle.borderBottomWidth, 10);
    }

    // Calculate the position of the popup relative to the container.
    // The container needs to be non-statically positioned, either fixed, relative or absolute,
    // because the popup is position: absolute.
    return {
      top: (targetOffset.top - containerOffset.top) + $target.outerHeight() +
        assetSectionHeight + hrHeight * 2, // eslint-disable-line no-mixed-operators
      left: targetOffset.left - containerOffset.left,
    };
  }

  addAssetSuggestion(event, target, field, description, inputText) {
    const {
      viewModel,
      element,
      pickerContainer,
      activityLogger,
      scenario,
    } = this.props;
    if (!_.isEmpty(target)) {
      const targetSelector = `.${target.className.split(' ').join('.')}`;
      $(targetSelector).val(description);
      viewModel.model.set(field, description);
      element.trigger('input-changed', event);
      activityLogger.signal(`${field}, ${description}`, `${scenario} asset suggestions select`);
    }
    if (!_.isEmpty(inputText)) {
      activityLogger.signal(`${field}, ${description}`, `${scenario} auto complete asset suggestions select.`);
    } else {
      activityLogger.signal(`${field}, ${description}`, `${scenario} inline recommendation asset suggestions select.`);
    }

    event.stopPropagation();
    event.preventDefault();
    // Hide picker
    ReactDOM.unmountComponentAtNode(pickerContainer);
  }

  render() {
    const {
      container, i18n, target, field, itemsToDisplay, activityLogger, scenario, permissions, input,
    } = this.props;

    const position = this.getDisplayPosition(target, container, permissions);

    const containerStyle = {
      display: 'block', left: `${position.left}px`, top: `${position.top}px`, zIndex: 20,
    };

    let pickerTitle = '';
    if (field.startsWith('Headline')) {
      pickerTitle = i18n.getString('Ad_Strength_Suggestion_Picker_Title_Headline');
    } else if (field.startsWith('LongHeadline')) {
      pickerTitle = i18n.getString('Ad_Strength_Suggestion_Picker_Title_LongHeadline');
    } else if (field.startsWith('Description')) {
      pickerTitle = i18n.getString('Ad_Strength_Suggestion_Picker_Title_AdText');
    }
    const pickerTitleStyle = { padding: '10px 10px 3px 10px', fontWeight: 'bold' };

    let contentView = null;
    const contentClasses = ['picker-list'];
    contentView = itemsToDisplay.map(({ Text }, index) => (
      <li key={index}>
        <a
          role="menuitem"
          arial-label={Text}
          href="#"
          onClick={event => this.addAssetSuggestion(event, target, field, Text, input)}
          key={index}
          data-index={index}
        >
          {Text ? <div className="type-normal">{Text}</div> : null}
        </a>
      </li>), this);

    _.each(itemsToDisplay, ({ Text }) => {
      activityLogger.signal(`${field}, ${Text}`, `${scenario} asset suggestions view`);
    });

    if (!_.isEmpty(itemsToDisplay)) {
      activityLogger.signal(`${field}, ${Text}`, `${scenario} asset suggestions page view`);
      if (!_.isEmpty(input)) {
        activityLogger.signal(`${field}, ${input}`, `${scenario} auto complete asset suggestions view.`);
      } else {
        activityLogger.signal(`${field}, ${input}`, `${scenario} inline recommendation asset suggestions view.`);
      }
    }

    return (
      <ul className={classnames('dropdown-menu', ...contentClasses)} role="menu" style={containerStyle}>
        <li className="ad-strength-suggestion-picker-title" style={pickerTitleStyle}>
          {pickerTitle}
        </li>
        {contentView}
      </ul>
    );
  }
}

AdStrengthSuggestionPicker.propTypes = {
  itemsToDisplay: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  })),
  target: PropTypes.shape({}).isRequired,
  container: PropTypes.shape({ offset: PropTypes.func }),
  pickerContainer: PropTypes.objectOf(PropTypes.any).isRequired,
  viewModel: PropTypes.objectOf(PropTypes.any).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  field: PropTypes.string.isRequired,
  element: PropTypes.objectOf(PropTypes.any).isRequired,
  activityLogger: PropTypes.shape({
    signal: PropTypes.func.isRequired,
  }).isRequired,
  scenario: PropTypes.string.isRequired,
  permissions: PropTypes.shape({
    IsMultiMediaAdsPhase2Enabled: PropTypes.bool,
  }),
  input: PropTypes.string.isRequired,
};

export class AdStrengthSuggestionController {
  constructor({
    containerSelector,
    pageContext,
    i18n,
    activityLogger,
  }) {
    this.containerSelector = containerSelector;
    this.pageContext = pageContext || {};
    this.i18n = i18n;
    this.cachedAutoCompleteSuggestions = {};
    this.cachedCreationSuggestions = {};
    this.cachedBusiness = {};
    this.activityLogger = activityLogger;

    const state = DependencyResolver.get('component/state/index');
    state.set('textSuggestions', {
      autoCompleteSuggestions: this.cachedAutoCompleteSuggestions,
      creationSuggestions: this.cachedCreationSuggestions,
      businessNameSuggestions: this.cachedBusiness,
    });
  }

  keydown(event) {
    switch (event.key) {
      case 'Escape':
        this.hidePicker();
        break;
      default:
        break;
    }
  }

  registerGlobalEvents(target) {
    $(window).on('click', event => this.clickedAway(event));
    $(target).on('keydown', event => this.keydown(event));
  }

  hidePicker() {
    const existingPickerContainer = $('.mma-ad-strength-suggestion-container');
    if (containerExists(existingPickerContainer)) {
      ReactDOM.unmountComponentAtNode(_.first(existingPickerContainer));
    }
    $(window).off('click', this.clickedAway);
    $(this.target).off('keydown', this.keydown);
  }

  clickedAway(event) {
    const target = $(event.target);
    if (target.closest('.ad-strength-suggestion-helper-area').length === 0 &&
      target.closest('.mma-ad-strength-suggestion-container').length === 0) {
      this.hidePicker();
    }
  }

  // eslint-disable-next-line max-len
  renderPicker(target, field, viewModel, assetType, element, scenario, input, finalUrl) {
    const { containerSelector, i18n } = this;
    const existingPickerContainer = $('.mma-ad-strength-suggestion-container');
    let suggestions
      = this.filterSuggestion(viewModel, assetType, input, field, finalUrl);
    if (field === 'BusinessName' && input) {
      suggestions = [];
    }
    if (!_.isEmpty(suggestions) && containerExists(existingPickerContainer)) {
      const pickerContainer = _.first(existingPickerContainer);
      // render latest picker
      ReactDOM.render(React.createElement(AdStrengthSuggestionPicker, {
        element,
        itemsToDisplay: suggestions,
        target,
        field,
        container: $(containerSelector),
        pickerContainer,
        viewModel,
        assetType,
        i18n,
        activityLogger: this.activityLogger,
        scenario,
        permissions: this.pageContext.Permissions,
        input,
      }), pickerContainer);
      this.registerGlobalEvents(target);
    } else {
      this.hidePicker();
    }
  }

  // Only value of target field which is the input and the finalUrl matter.
  isAutoCompleteSuggestionCached(assetType, finalUrl, input) {
    const {
      cachedAutoCompleteSuggestions,
    } = this;

    return (
      finalUrl &&
      assetType &&
      input &&
      _.get(cachedAutoCompleteSuggestions, [finalUrl, assetType, input])
    );
  }

  isCreationSuggestionCached(finalUrl) {
    const {
      cachedCreationSuggestions,
    } = this;

    return (
      finalUrl &&
      cachedCreationSuggestions[finalUrl] &&
      !_.isEmpty(cachedCreationSuggestions[finalUrl])
    );
  }

  isBusinessCached(finalUrl) {
    const {
      cachedBusiness,
    } = this;

    return (
      finalUrl &&
      cachedBusiness[finalUrl] &&
      !_.isEmpty(cachedBusiness[finalUrl])
    );
  }

  filterSuggestion(viewModel, assetType, input, field, finalUrl) {
    const targetSuggestions =
    // eslint-disable-next-line no-nested-ternary
    input ?
      this.cachedAutoCompleteSuggestions[finalUrl] && this.cachedAutoCompleteSuggestions[finalUrl][assetType] && this.cachedAutoCompleteSuggestions[finalUrl][assetType][input] :
      (assetType === assetSuggestionType.BusinessName ?
        this.cachedBusiness[finalUrl] : this.cachedCreationSuggestions[finalUrl]);
    const filteredSuggestions =
    _.filter(targetSuggestions, (suggestion) => {
      if (suggestion.AssetType.toLowerCase() !== assetType || _.isEmpty(suggestion.Text)) {
        return false;
      }
      const suggestionContent = suggestion.Text.toLowerCase();
      // If the input field is not empty, provide suggestions which start with the inputted text.
      if (!_.isEmpty(input) && !suggestionContent.startsWith(input.toLowerCase())) {
        return false;
      }

      /* Filter out asset that have been inputted */
      if (field.startsWith('Headline')) {
        for (let i = 0; i < viewModel.showHeadlineCount(); i++) {
          const key = `Headline${i}`;
          if (suggestion.Text === viewModel.model.get(key)) {
            return false;
          }
        }
      } else if (field.startsWith('LongHeadline')) {
        for (let i = 0; i < viewModel.showLongHeadlineCount(); i++) {
          const key = `LongHeadline${i}`;
          if (suggestion.Text === viewModel.model.get(key)) {
            return false;
          }
        }
      } else if (field.startsWith('Description')) {
        for (let i = 0; i < viewModel.showDescriptionCount(); i++) {
          const key = `Description${i}`;
          if (suggestion.Text === viewModel.model.get(key)) {
            return false;
          }
        }
      }

      return true;
    });
    return filteredSuggestions;
  }

  autoFillSuggestionsMultipleField({
    view,
    viewModel,
    finalUrl,
    scenario,
  }) {
    const model = viewModel.model.toJSON();
    const nonEmptyHeadlineCount =
      _.filter(headlineFields, field => !_.isEmpty(model[field])).length;
    if (nonEmptyHeadlineCount < viewModel.autoFillHeadlineCount) {
      const headlineSuggestions = this.filterSuggestion(viewModel, assetSuggestionType.Headline, null, 'Headline', finalUrl);
      for (let i = 0, j = 0; i < viewModel.showHeadlineCount() &&
        i < headlineSuggestions.length &&
        j < viewModel.autoFillHeadlineCount - nonEmptyHeadlineCount; i++) {
        const targetField = headlineFields[i];
        const targetSuggestion = headlineSuggestions[i].Text;
        if (_.isEmpty(model[targetField])) {
          $(`.${targetField}-value`).val(targetSuggestion);
          viewModel.model.set(targetField, targetSuggestion);
          view[targetField].trigger('input-changed');
          this.activityLogger.signal(`${targetField}, ${targetSuggestion}`, `${scenario} asset suggestions auto-fill`);
          j++;
        }
      }
    }

    const nonEmptyLongHeadlineCount =
      _.filter(longHeadlineFields, field => !_.isEmpty(model[field])).length;
    if (nonEmptyLongHeadlineCount < viewModel.autoFillLongHeadlineCount) {
      const longHeadlineSuggestions = this.filterSuggestion(viewModel, assetSuggestionType.LongHeadline, null, 'LongHeadline', finalUrl);
      for (let i = 0, j = 0; i < viewModel.showLongHeadlineCount() &&
        i < longHeadlineSuggestions.length &&
        j < viewModel.autoFillLongHeadlineCount - nonEmptyLongHeadlineCount; i++) {
        const targetField = longHeadlineFields[i];
        const targetSuggestion = longHeadlineSuggestions[i].Text;
        if (_.isEmpty(model[targetField])) {
          $(`.${targetField}-value`).val(targetSuggestion);
          viewModel.model.set(targetField, targetSuggestion);
          view[targetField].trigger('input-changed');
          this.activityLogger.signal(`${targetField}, ${targetSuggestion}`, `${scenario} asset suggestions auto-fill`);
          j++;
        }
      }
    }

    const nonEmptyDescriptionCount =
      _.filter(descriptionFields, field => !_.isEmpty(model[field])).length;
    if (nonEmptyDescriptionCount < viewModel.autoFillDescriptionCount) {
      const descriptionSuggestions = this.filterSuggestion(viewModel, assetSuggestionType.Description, null, 'Description', finalUrl);
      for (let i = 0, j = 0; i < viewModel.showDescriptionCount() &&
        i < descriptionSuggestions.length &&
        j < viewModel.autoFillDescriptionCount - nonEmptyDescriptionCount; i++) {
        const targetField = descriptionFields[i];
        const targetSuggestion = descriptionSuggestions[i].Text;
        if (_.isEmpty(model[targetField])) {
          $(`.${targetField}-value`).val(targetSuggestion);
          viewModel.model.set(targetField, targetSuggestion);
          view[targetField].trigger('input-changed');
          this.activityLogger.signal(`${targetField}, ${targetSuggestion}`, `${scenario} asset suggestions auto-fill`);
          j++;
        }
      }
    }
  }

  autoFillSuggestionsSingleField({
    view,
    viewModel,
    finalUrl,
    scenario,
  }) {
    const model = viewModel.model.toJSON();
    _.each(singleAssetSuggestionType, (viewField, field) => {
      if (_.isEmpty(model[field])) {
        const headlineSuggestions = this.filterSuggestion(
          viewModel,
          assetSuggestionType[field], null, field, finalUrl
        );
        if (!_.isEmpty(headlineSuggestions)) {
          const targetSuggestion = headlineSuggestions[0].Text;
          const targetField = `.${field}-value`;

          $(targetField).val(targetSuggestion);
          viewModel.model.set(field, targetSuggestion);
          view[viewField].trigger('input-changed');
          this.activityLogger.signal(`${field}, ${targetSuggestion}`, `${scenario} asset suggestions auto-fill`);
        }
      }
    });
  }

  getAdStrengthSuggestion({
    assetType,
    target,
    field,
    viewModel,
    element,
    scenario,
  }) {
    const {
      containerSelector, pageContext,
    } = this;
    const existingPickerContainer = $('.mma-ad-strength-suggestion-container');
    if (!containerExists(existingPickerContainer)) {
      const containerToUse = $('<div class="mma-ad-strength-suggestion-container open"/>');
      containerToUse.appendTo($(containerSelector));
    } else {
      this.hidePicker();
    }

    const repository = new AdStrengthSuggestionRepository({
      field,
      assetType,
      viewModel,
      pageContext,
      scenario,
    });

    const finalUrl = !_.isEmpty(viewModel.model.get('FinalUrls')) ?
      _.first(viewModel.model.get('FinalUrls')) : null;

    const inputText = viewModel.model.get(field);
    const isAutoComplete = !_.isEmpty(inputText);

    if (isAutoComplete) {
      this.activityLogger.signal(`${field}`, `${scenario} auto complete displayed`);
    }
    return new Promise((resolve) => {
      if (isValidUrl(finalUrl) && isAutoComplete && !this.isAutoCompleteSuggestionCached(assetType, finalUrl, inputText)) {
        repository.fetchAdStrengthSuggestion(true)
          .then(({ data }) => {
            this.cachedAutoCompleteSuggestions =
            {
              ...this.cachedAutoCompleteSuggestions,
              [finalUrl]: {
                ...this.cachedAutoCompleteSuggestions[finalUrl],
                [assetType]: {
                  ..._.get(this.cachedAutoCompleteSuggestions, [finalUrl, assetType]),
                  [inputText]: data,
                },
              },
            };
            resolve();
          });
      } else {
        // No field value found in the model.
        // So we can just read it from the cache which is guranteed by getAdStrengthSuggestionForURL
        // which will be called everytime URL is altered.
        resolve();
      }
    })
      .then(() => {
        this.renderPicker(
          target,
          field,
          viewModel,
          assetType,
          element,
          scenario,
          inputText,
          finalUrl
        );
      });
  }

  getAdStrengthSuggestionForURL({
    view,
    viewModel,
    scenario,
  }) {
    const {
      pageContext,
    } = this;

    const repository = new AdStrengthSuggestionRepository({
      viewModel,
      pageContext,
      scenario,
    });

    const finalUrl = _.first(viewModel.model.get('FinalUrls'));

    if (isValidUrl(finalUrl)) {
      const creationFetchPromise = (this.isCreationSuggestionCached(finalUrl) ?
        Promise.resolve({ data: this.cachedCreationSuggestions[finalUrl] }) :
        repository.fetchAdStrengthSuggestion(false)
      ).then(({ data }) => {
        this.cachedCreationSuggestions[finalUrl] = data;
        viewModel.currentSuggestions = data;
        // audience campaign -> ad
        if (view.isAudienceCampaign) {
          if (pageContext.Permissions && !pageContext.Permissions.IsResponsiveAdRecommendationMSANEnabled) {
            if (pageContext.Permissions &&
            pageContext.Permissions.IsAudienceCampaignMultiMediaAdsEnabled) {
              this.autoFillSuggestionsMultipleField({
                view, viewModel, finalUrl, scenario,
              });
            } else {
              this.autoFillSuggestionsSingleField({
                view, viewModel, finalUrl, scenario,
              });
            }
          }
        // search campaign -> multimedia ad
        } else if (pageContext.Permissions &&
          pageContext.Permissions.IsMMAAutoFillEnabled) {
          this.autoFillSuggestionsMultipleField({
            view, viewModel, finalUrl, scenario,
          });
        }
      });
      const businessFetchPromise = (this.isBusinessCached(finalUrl) ?
        Promise.resolve({ data: this.cachedBusiness[finalUrl] }) :
        repository.fetchBusinessInfo(false)
      ).then(({ data }) => {
        this.cachedBusiness[finalUrl] = data;
      }).catch((e) => {
        this.activityLogger.signal(`${e.responseText}`, 'finalUrl mismatch');
      });
      return Promise.all([
        creationFetchPromise,
        businessFetchPromise,
      ]);
    }

    return Promise.resolve();
  }
}
